import { Injectable } from "@angular/core";
import { BehaviorSubject, fromEvent, map, Observable } from "rxjs";
import { debounceTime } from "rxjs/operators";

import { PdfDropdown } from "../types/pdf-dropdown";
import { PdfDropdownManager } from "../types/pdf-dropdown-manager";
import { EventItemModel } from "../models/event-item.model";
import { DirectoryItemModel } from "../../advanced-search/directory-search/models/directory-item.model";

@Injectable({
    providedIn: "root"
})
export class BookletService {
    public bookletItems$: BehaviorSubject<Array<EventItemModel>>;

    public constructor() {
        this.bookletItems$ = new BehaviorSubject<Array<EventItemModel>>(this.getItems());

        fromEvent(window, "sc-my-favourites__update").pipe(
            debounceTime(200)
        ).subscribe(e => this.bookletItems$.next(this.getItems()));
    }

    public get isBookletAvailable(): boolean {
        return !!this.pdfDropdownManager;
    }

    private get pdfDropdownManager(): InstanceType<PdfDropdownManager> | undefined {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
        return window.$.sc?.pdfDropdown;
    }

    private getItems(): Array<EventItemModel> {
        return this.isBookletAvailable
            ? this.pdfDropdownManager.getItems()
            : [];
    }

    public clear(): void {
        this.pdfDropdownManager?.removeAll();
        this.bookletItems$.next(this.getItems());
    }

    public removeItem(eventId: string): void {
        const bookletItem = this.getItems().find(i => i.eventId === eventId);
        if (!!bookletItem) {
            this.pdfDropdownManager?.removeEvent(bookletItem.key);
        }
        this.bookletItems$.next(this.getItems());
    }

    public addItem(directoryItem: DirectoryItemModel, url: string): void {
        if (this.getItems().some(i => i.eventId === directoryItem.id)) {
            return;
        }

        const absoluteUrl = url.startsWith("http")
            ? url
            : window.location.protocol + "//" + window.location.host + url;

        this.pdfDropdownManager?.addEvent(directoryItem.id, directoryItem.name, absoluteUrl);
        this.bookletItems$.next(this.getItems());
    }

    public isInBooklet$(eventId: string): Observable<{is: boolean}> {
        return this.bookletItems$.pipe(
            map(items => {
                return {
                    is: items.some(i => i.eventId === eventId)
                };
            })
        );
    }
}
